import script from "./TitleDivider.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDivider.vue?vue&type=script&setup=true&lang=ts"

import "./TitleDivider.vue?vue&type=style&index=0&id=0db8b55e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db8b55e"]])

export default __exports__